import $ from 'jquery';
import { updateNavbarItemVisibility } from '~core/navbar/utils';

// Narrow, feature-focused checks for print support to avoid UA pitfalls.
function isFirefoxUA() {
  try {
    return /firefox/i.test(navigator.userAgent);
  } catch (_) {
    return false;
  }
}

function hasNativePrint() {
  return typeof window?.print === 'function';
}

export const initBrowsersManagement = () => {
  const canPrint = hasNativePrint() && !isFirefoxUA();
  try {
    // Lightweight diagnostics to confirm runtime decision (use console.log to avoid Verbose filter)
    // eslint-disable-next-line no-console
    console.log('[initBrowsersManagement] print support:', {
      ua: navigator.userAgent,
      hasNativePrint: hasNativePrint(),
      isFirefoxUA: isFirefoxUA(),
      canPrint,
    });
  } catch (e) {
    console.error('Failed to log browser print diagnostics', e);
  }

  if (canPrint) {
    $('#editor-menu-print').show();
  } else {
    $('#editor-menu-print').hide();
  }

  updateNavbarItemVisibility(['#editor-menu-print']);
};
